export enum ElementType {
  Text = "Text",
  Collection = "Collection",
  Date = "Date",
  Enumeration = "Enumeration",
  Heading = "Heading",
  Checkbox = "Checkbox",
  AddButton = "AddButton",
}
